import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { useCurrentUserKeyEnhancer } from 'src/common/hooks/useCurrentUserKeyEnhancer';
import { getSpeakerCourses } from 'src/common/services/speakers';

export const useSpeakerRelatedCourses = (speakerId?: number) => {
  const { key, isAuthenticated } = useCurrentUserKeyEnhancer([
    QueryKey.SpeakerRelatedCourses,
    speakerId,
  ]);

  return useQuery(
    key,
    () => (speakerId ? getSpeakerCourses(speakerId, 4, isAuthenticated) : undefined),
    {
      enabled: !!speakerId,
    },
  );
};
